module.exports = __webpack_public_path__ + "static/media/Jermaime_4_Empower Bra.44e6e6f9.jpeg";